const DATABASE_NAME = 'CERTIFICATION'

export default {
  data () {
    return {

    }
  },
  computed: {},
  methods: {
    async databaseConnect () {
      return new Promise((resolve, reject) => {
        const request = window.indexedDB.open(DATABASE_NAME, 1)
        request.onerror = e => {
          console.log('Error opening db', e)
          reject('Error')
        }

        request.onsuccess = e => {
          resolve(e.target.result)
        }

        request.onupgradeneeded = e => {
          const db = e.target.result
          db.createObjectStore('steps', { keyPath: 'name' })

          if (!db.objectStoreNames.contains('inspectionDraft')) {
            db.createObjectStore('inspectionDraft', { keyPath: 'id' })
          }

        }
      })
    },

    async deleteDatabase () {
      await window.indexedDB.deleteDatabase(DATABASE_NAME)
    },

    // ------------------ Inspection Draft ------------------

    async addInspectionDraft (payload) {
      const db = await this.databaseConnect()

      return new Promise(resolve => {
        let transaction = db.transaction('inspectionDraft', 'readwrite')
        transaction.oncomplete = () => {
          db.close()
        }
        let inspectionDraft = transaction.objectStore('inspectionDraft')
        let request = inspectionDraft.put(payload)

        request.onsuccess = () => {
          resolve(request.result)
        }
        request.onerror = () => {
          console.log('error PUT')
        }
      })
    },

    async getInspectionDraft (payload) {
      const db = await this.databaseConnect()

      return new Promise(resolve => {
        let transaction = db.transaction('inspectionDraft', 'readonly')
        transaction.oncomplete = () => {
          db.close()
        }

        let inspectionDraft = transaction.objectStore('inspectionDraft')
        let request = inspectionDraft.get(payload)

        request.onsuccess = () => {
          if (request.result) {
            resolve(request.result)
          }
        }
        request.onerror = () => {
          console.log('error GET')
        }
      })
    },

    async deleteInspectionDraft (payload) {
      const db = await this.databaseConnect()

      return new Promise(resolve => {
        let transaction = db.transaction('inspectionDraft', 'readwrite')
        transaction.oncomplete = () => {
          db.close()
        }

        let inspectionDraft = transaction.objectStore('inspectionDraft')
        let request = inspectionDraft.delete(payload)

        request.onsuccess = () => {
          if (request.result) {
            resolve(request.result)
          }
        }
        request.onerror = () => {
          console.log('error delete')
        }
      })

    },

    // ----------------------- Steps ------------------------

    async setDataBlock (payload) {
      const db = await this.databaseConnect()

      return new Promise(resolve => {
        const trans = db.transaction(['steps'], 'readwrite')
        trans.oncomplete = () => {
          db.close()
          resolve()
        }

        trans.objectStore('steps').put(payload)
      })
    },
    async getDataBlock () {
      const db = await this.databaseConnect()

      return new Promise(resolve => {
        const trans = db.transaction(['steps'], 'readonly')
        trans.oncomplete = () => {
          resolve(steps)
        }

        const store = trans.objectStore('steps')
        const steps = []

        store.openCursor().onsuccess = e => {
          const cursor = e.target.result
          if (cursor) {
            steps.push(cursor.value)
            cursor.continue()
          }
        }
      })
    }
  }
}
